import userdata from '../../../go/trefoil/configure/userdata.sh?raw';
import { replaceVariables } from '../manifest';

export function mkUserData(
  configureKey: string,
  fqdn: string,
  icFile: string,
  icSHA: string,
  icURL?: string,
  extraAllowedOrigins?: string,
  publicTrefoilURL?: string
): string {
  if (!icURL) {
    icURL = `https://cstatic.app/leaf/dist/${icFile}`;
  }

  return replaceVariables(userdata, {
    URL: icURL,
    SHA: icSHA,
    FQDN: fqdn,
    TREFOIL_URL: publicTrefoilURL || '',
    ALLOWED_ORIGIN: extraAllowedOrigins || '',
    CONFIGURE_KEY: configureKey,
    DEBUG: import.meta.env.DEV ? '1' : '',
  });
}
